import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LsqDataSource } from '@lsq-frontend/angular-shared/api-service';
import { forLifeOf, ignoreNullish, LifecycleAware } from '@lsq-frontend/common-ui';
import { map, mapTo, pluck, startWith } from 'rxjs/operators';
import {
    GetInvoiceSummaryRequest,
    GetInvoiceSummaryService,
    InvoiceSummaryDto
} from '@lsq-frontend/remote-services/financing-graphql';

@LifecycleAware()
@Component({
    selector: 'supplier-details-open-invoices',
    template: `
        <account-invoice-summary-tile
            id="invoice-summary-tile"
            [dataSource]="invoiceSummaryDataSource"
        ></account-invoice-summary-tile>
    `
})
export class SupplierDetailsOpenInvoicesTile implements OnDestroy {
    private _invoiceSummaryRawData$ = this._getInvoiceSummaryService.dataStream.pipe(
        pluck('invoiceSummary'),
        ignoreNullish()
    );
    public invoiceSummaryDataSource = new LsqDataSource<InvoiceSummaryDto>({
        data$: this._invoiceSummaryRawData$.pipe(
            map((invoiceSummary) => {
                if (invoiceSummary === undefined) {
                    return {
                        totalEarlyPaid: {
                            cents: 0,
                            currencyCode: 'USD'
                        },
                        earlyPaidInvoiceCount: 0,
                        totalEligible: {
                            cents: 0,
                            currencyCode: 'USD'
                        },
                        eligibleInvoiceCount: 0,
                        totalIneligible: {
                            cents: 0,
                            currencyCode: 'USD'
                        },
                        ineligibleInvoiceCount: 0,
                        totalOpen: {
                            cents: 0,
                            currencyCode: 'USD'
                        },
                        totalOpenInvoiceCount: 0,
                        totalRevoked: {
                            cents: 0,
                            currencyCode: 'USD'
                        }
                    };
                }

                return invoiceSummary;
            })
        ),
        loading$: this._invoiceSummaryRawData$.pipe(mapTo(false), startWith(true))
    });

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _getInvoiceSummaryService: GetInvoiceSummaryService
    ) {
        this._activatedRoute.params.pipe(forLifeOf(this)).subscribe((params) => {
            if (params.sellerKey) {
                this._getInvoiceSummaryService.execute(
                    new GetInvoiceSummaryRequest({
                        sellerKeys: [params.sellerKey]
                    })
                );
                this.invoiceSummaryDataSource.connect();
            }
        });
    }

    public ngOnDestroy(): void {}
}
